import * as React from "react"
import PortfolioTilesOuter from "../../components/portfolioTilesOuter"
import { graphql } from "gatsby"

const FilmsPage = (props) => {
    const nodes = props.data.contentfulPortfolioOrder.order
    return (
        <PortfolioTilesOuter nodes={nodes} subfolder="/films/" />
    )
}

export default FilmsPage

export const query = graphql`
query allFilms {
  contentfulPortfolioOrder(category: {eq: "Film"}) {
    order {
      id
      title
      subtitle
      shouldShowSubtitle
      slug
      thumbnail {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
}
`

export const Head = () => {
    return (
        <>
            <title>FILMS - BO MIRHOSSENI</title>
        </>
    )
}